import styled, { css } from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils'

export const StyledFilter = styled.div`
  font-size: 12px;
  font-weight: bold;
  line-height: 26px;
  margin: auto 20px;
  text-align: center;
  padding: 2px 10px;
  color: ${colors.WHITE};
  background-color: ${colors.MEDIUM_GRAY};
  border-radius: 100px;
`;

export const FilterButton = styled.button`
  padding: 0 5px;
  > svg {
    fill: ${colors.LIGHT_GRAY};
    margin: 0px 0px 2px;
  }
`;

export const StyledEmptyList = styled.div`
  text-align: center;
  color: rgba(104,129,144,0.6);

  > svg {
    fill: ${colors.GRAY};
  }
  >a {
    > button {
      font-size: 12px;
    }
  }
`;

export const EmptyText = styled.p`
  padding-bottom: 40px;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #E7EBEC;

  + tr {
    border-top: solid 1px #E7EBEC;
  }
`;

const tableCellStyles = css`
  padding: 18px 0;
  width: 288px;
  margin-right: 0px;
  ${({ isNumber }) => isNumber && `
    width: 60px;
  `}

  &:first-child {
    width: 204px;
    margin-right: 20px;
  }

  &:nth-child(2) {
    ${media.desktop`
      width: 204px;
    `}

    ${media.tablet`
      width: 204px;
    `}

    ${media.mobile`
      width: 195px;
    `}
  }

  &:nth-child(3) {
    ${media.desktop`
      width: 156px;
    `}
    ${media.tablet`
      width: 217px;
    `}
    ${media.mobile`
      display:none;
    `}
  }

  &:last-child {
    padding-right: 20px;
    width: 220px;
      ${media.desktop`
        padding-right: 0px;
      `}

      ${media.tablet`
        padding-right: 0px;
      `}
      ${media.mobile`
        padding-right: 0px;
      `}
  }
`;

export const TableData = styled.div`
  ${tableCellStyles}
  ${({ isLink }) => isLink && `
    &:hover {
      cursor: pointer;
      text-decoration: underline;
      color: ${colors.MAIN_COLOR};
    }
  `}

  ${({ isIcon }) => isIcon && `
    text-align: right;
    min-width: inherit;
  `}

  ${({ isActive }) => typeof(isActive) === "boolean" && `
    span {
      margin-right: 18px;
      display: block;
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: #${isActive ? '0CFF00' : 'E7EBEC'};
    }
  `}

  > a > svg {
    fill: ${colors.LIGHT_GRAY};
  }
`;

export const Wrapper = styled.div`
  padding-bottom: 3em;
`;

export const Title = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.button`
  margin: 10px 30px;
  color: #183748;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 14px;

  &:hover {
    color: ${colors.MAIN_COLOR};
  }
`;

export const TableWrapper = styled.div`
  text-align: center;
  margin-top: 18px;
`;

export const StyledTable = styled.table`
  width: 100%;
  empty-cells: show;
  background-color: ${colors.WHITE};
  text-align: left;
`;

export const TableHead = styled.thead`
  > tr {
    height: 40px;
    text-align: left;

    th {
      color: ${colors.DARK};
      font-size: 8px;
      font-weight: bold;
      letter-spacing: 2px;
      line-height: 14px;
      text-transform: uppercase;
      padding-bottom: 10px;
    }
  }
`;

export const TableHeader = styled.th`${tableCellStyles}`;

export const TableBody = styled.tbody`
  > tr {
    border-bottom: 1px solid #E7EBEC;
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    height: 60px;
    color:  ${colors.BODY};
  }
`;

export const StatusFilterList = styled.div`
  display: flex;
  width:100%;
  margin-top: 40px;
`;

export const StatusFilterOption = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #B9C3C8;
  font-size: 10px;
  font-weight: normal;
  font-family: poppins, sans-serif;
  letter-spacing: 2px;
  text-transform: uppercase;
  height: 14px;
  line-height: 14px;
  margin: 0.5em 2em;

  &:first-of-type {
    margin-left: 0;
  }

  &.active,
  &:hover  {
    color: black;
  }
`;

export const StatusFilterOptionItem = styled.div`
  box-shadow: 0 2px 0 0 ${({ isActive }) => isActive ? colors.ACTIVE_COLOR : 'transparent'};
  padding: 0 0 0.5em 0;
`;

export const RowHyperlink = styled.a`
  color: ${colors.MAIN_COLOR};
  text-decoration: underline;

  &:hover {
    cursor: pointer;
    color: ${colors.MAIN_COLOR};
  }
`;

export const ModalBody = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${colors.BODY};

  p {
    margin: 0 0 16px;
  }

  strong {
    color: ${colors.DARK};
  }
`;

export const ConfirmInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  margin: 4px 0 8px;
  font-size: 14px;
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 4px;
  color: ${colors.BODY};

  &:focus {
    outline: none;
    border-color: ${colors.MAIN_COLOR};
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

const modalButtonBase = css`
  cursor: pointer;
  padding: 12px 24px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  border-radius: 4px;
  border: 1px solid transparent;

  /*
   * Keyboard focus must stay visible — this is a destructive-confirm dialog, so
   * a keyboard user has to see whether Cancel or the danger button is focused.
   * We suppress the outline ONLY for pointer focus (:focus:not(:focus-visible))
   * and render a high-contrast, offset ring for keyboard focus. The 2px white
   * inset gap keeps the ring legible against the dark danger/archive fills.
   */
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${colors.DARK};
    outline-offset: 2px;
    box-shadow: 0 0 0 2px ${colors.WHITE};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

export const CancelButton = styled.button`
  ${modalButtonBase}
  background-color: ${colors.WHITE};
  border-color: ${colors.LIGHT_GRAY};
  color: ${colors.MEDIUM_GRAY};

  &:hover:not(:disabled) {
    color: ${colors.DARK};
  }
`;

export const DangerButton = styled.button`
  ${modalButtonBase}
  background-color: ${colors.RED};
  color: ${colors.WHITE};

  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }
`;

export const ArchiveButton = styled.button`
  ${modalButtonBase}
  background-color: ${colors.MAIN_COLOR};
  color: ${colors.WHITE};

  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }
`;